import React from 'react';
import { useDispatch } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';
import { useForm } from '@dotone/react-ui-core/hooks';
import { useShallowEqualSelector, useTranslate } from '@hooks';
import { updateNetworkUser } from '@actions';
import { FormGroup, Form } from 'reactstrap';
import { FormAction, Input, Button, Label } from '@dotone/react-ui-core';

const NetworkUserProfileForm = ({ user, ...otherProps }) => {
  const { t } = useTranslate('profile');
  const { tShared } = useTranslate('networkUser', 'model');
  const dispatch = useDispatch();

  const { connectForm, handleSubmit, setError } = useForm({
    defaultValues: user,
  });

  const {
    isLoading,
    status,
    data = { message: {} },
  } = useShallowEqualSelector(({ networkUserUpdate }) => networkUserUpdate);

  const handleSubmitForm = (values) => {
    dispatch(
      updateNetworkUser(user.id, {
        ...values,
      })
    );
  };

  useDeepCompareEffect(() => {
    if (status === 'error' && data.message) {
      Object.keys(data.message).forEach((key) =>
        setError(key, { type: 'custom', message: data.message[key] })
      );
    }
  }, [status, data.message, setError, user]);

  return (
    <Form onSubmit={handleSubmit(handleSubmitForm)} {...otherProps}>
      {connectForm(
        <>
          <FormGroup>
            <Label for="email" required>
              {tShared('email')}
            </Label>
            <Input
              name="email"
              disabled
              placeholder={tShared('email')}
              rules={{ required: true }}
            />
          </FormGroup>
          <FormGroup>
            <Label for="firstName" required>
              {tShared('firstName')}
            </Label>
            <Input name="firstName" placeholder={tShared('firstName')} rules={{ required: true }} />
          </FormGroup>
          <FormGroup>
            <Label for="lastName" required>
              {tShared('lastName')}
            </Label>
            <Input name="lastName" placeholder={tShared('lastName')} rules={{ required: true }} />
          </FormGroup>
          <FormAction align="right">
            <Button variant="save" color="primary" submitting={isLoading}>
              {t('edit.submit')}
            </Button>
          </FormAction>
        </>
      )}
    </Form>
  );
};

export default NetworkUserProfileForm;
